module.exports = __webpack_public_path__ + "img/flag_uz.3aae5ae2.svg";